import { useEffect, useState } from "react";
import { inActive } from "../../utility/message";
import { Button, Dialog, DialogActions, DialogContent, DialogTitle, Grid, Typography } from "@mui/material";
import CustomTextField from "../commoncomponents/CustomTextField";
import ContractManagementRepository from "../../api/repositories/contractManagementRepository";


const InactiveContractModalPopPup = ({ open, onClose,onConfirm,selectedRowData }) => {
    const [value, setValue] = useState({
        reasonForInactiveContract: "",
    });

    const [errors, setErrors] = useState({
        reasonForInactiveContract: false,
    });

    const [errorMessage, setErrorMessage] = useState({
        reasonForInactiveContract: "",
    });

    const handleChange = (value, name) => {
        setValue((previous) => ({
            ...previous,
            [name]: value,
        }));

        if (value.trim() !== "") {
            setErrors((prevErrors) => ({
                ...prevErrors,
                [name]: false,
            }));

            setErrorMessage((prevMessages) => ({
                ...prevMessages,
                [name]: "",
            }));
        }
    };

    const handleConfirm = async() => {
        const newErrors = {
            reasonForInactiveContract: value.reasonForInactiveContract.trim() === "",
        };

        const newErrorMessages = {
            reasonForInactiveContract: value.reasonForInactiveContract.trim() === "" ? "Reason is required" : "",
        };

        setErrors(newErrors);
        setErrorMessage(newErrorMessages);

        const isValid = !newErrors.reasonForInactiveContract;

        if (isValid) {
        const serviceType = selectedRowData?.serviceDesc === "FEMS" ? "fem" : "bem";
        const payload = {
            contractId: selectedRowData?.id || "",
            contractStatus: inActive?.fieldID || "",
            reasonForInactiveContract: value?.reasonForInactiveContract || "",
        };
            const response = await ContractManagementRepository?.updateContractinactiveStatus(serviceType,payload);
            onConfirm(response)
            onClose('yes');
        }
    };

    const handleClose = () => {
        onClose('no');
        setValue({
            reasonForInactiveContract: "",
        });

        setErrorMessage({
            reasonForInactiveContract: "",
        });

        setErrors({
            reasonForInactiveContract: false,
        });

    };

    useEffect(() => {
        if (open) {
            setErrors({
                reasonForInactiveContract: false,
            });
            setErrorMessage({
                reasonForInactiveContract: "",
            });
            setValue({
                reasonForInactiveContract: "",
            })
        }
    }, [open]);

    return (
        <Dialog open={open} onClose={(event, reason) => {
            if (reason !== "backdropClick" && reason !== "escapeKeyDown") {
                onClose(); // Only close if triggered explicitly
            }
        }}>
        <DialogTitle>
            <Typography variant="h6" style={{ fontWeight: "bold" }}> Inactive Contract </Typography>
        </DialogTitle>            
        <DialogContent>
                <Grid container spacing={2}>
                    <Grid item xs={6} md={6}>
                        <CustomTextField
                            label="Status"
                            id="contractStatus"
                            name='contractStatus'
                            value={inActive?.label || ""}
                            onChange={(e) => handleChange(e, 'contractStatus')}
                            disabled = {true}
                        />
                    </Grid>
                    <Grid item xs={6} md={6}>
                        <CustomTextField
                            label="Reason for Inactive"
                            id="reasonForInactiveContract"
                            name="reasonForInactiveContract"
                            value={value?.reasonForInactiveContract}
                            onChange={(e) => handleChange(e, 'reasonForInactiveContract')}
                            isMandatoryField={true}
                            error={errors.reasonForInactiveContract}
                            errorMessage={errorMessage.reasonForInactiveContract}
                        />
                    </Grid>
                </Grid>
            </DialogContent>
            <DialogActions>
                <Button onClick={handleClose} color="error">CANCEL</Button>
                <Button onClick={handleConfirm} color="primary">INACTIVE</Button>
            </DialogActions>
        </Dialog>
    );
};

export default InactiveContractModalPopPup;